const main = {
  //设置字体
  setFontSize: function () {
    let dWidth = document.body.clientWidth;
    if (dWidth > 500) {
      dWidth = 500;
    }
    document.getElementsByTagName("html")[0].style.fontSize = dWidth / 20 + "px";
  },
  //json转化为字符串
  jsonSortToStr: function (data) {
    var temp = [];
    for (let key in data) {
      temp.push(key + data[key]);
    }
    return temp.sort().join("");
  },
  funcUrlDel: function (paraArr) {
    var urlArr = window.location.href.split("?");
    var baseUrl = urlArr[0] + "?";
    var query = urlArr[1];
    if (!query) {
      //如果没有路由和参数则返回地址
      return window.location.href;
    }
    for (let index = 0; index < paraArr.length; index++) {
      if (query.indexOf(paraArr[index]) > -1) {
        var obj = {};
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=");
          obj[arr[i][0]] = arr[i][1];
        }
        delete obj[paraArr[index]];
        query = JSON.stringify(obj)
          .replace(/[\"\{\}]/g, "")
          .replace(/\:/g, "=")
          .replace(/\,/g, "&");
      }
    }

    return baseUrl + query;
  },
  setCookie: function (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
  },

  //取回cookie
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  watchScroll (tabOffsetop,controller) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //  当滚动超过 tab 时，实现吸顶效果
      if (scrollTop >= tabOffsetop) {
        controller = true
      } else {
        controller = false
      }
      return controller
  }
};
export default main;



// WEBPACK FOOTER //
// ./src/cmtapp/components/util/common.js